import { createContainer } from 'react-sweet-state';

import { ACTIONS, ResourceStore } from './ResourceStore';

export const ResourceStoreContainer = createContainer(ResourceStore, {
  onInit:
    () =>
    ({ setState, dispatch }, { state }) => {
      dispatch(ACTIONS.init());

      if (state) {
        setState(state);
      }
    },
  onUpdate:
    () =>
    ({ setState }, { state }) => {
      if (state) {
        setState(state);
      }
    },
});
